import { useState } from 'react';
import { useFlags, useFlagsReady } from 'src/feature-flags/FlagsHook';
import { AcceptLinkRef, getAcceptLinkRef } from 'src/auth/utils/inviteStorage';

/**
 * The accept-link a self-resend would be issued against, on pages that hold no invite
 * details of their own.
 *
 * `isReady` is false until LaunchDarkly has answered, so a caller that routes on the
 * absence of a target does not briefly act on a flag that is not really off.
 */
export const useInviteResendTarget = (): { isReady: boolean; target: AcceptLinkRef | null } => {
  const { flagEnabledExpiredInviteSelfResend } = useFlags();
  const isReady = useFlagsReady();
  const [storedRef] = useState(getAcceptLinkRef);

  return {
    isReady,
    target: flagEnabledExpiredInviteSelfResend ? storedRef : null,
  };
};
